import React, { Component } from 'react';
import * as Logger from 'js-logger';
import { connect } from "react-redux";
import {
 getTextHeight,
} from "../store/selectors/selectors";


export const PAGINATION_EVENTS = {
  // onRecalculate:  'onRecalculate',
  onEndReached: 'onEndReached',
  onBeginReached: 'onBeginReached',
  // onPageChanged:  'onPageChanged'
};

class PaginatedTextContainer extends Component {
  logger;
  wrapper;
  currentPage = 0;

  constructor(props) {
    super(props);
    this.state = {
      pages: 0,
      rowsPerPage: 10,
      data: []
    };
    this.logger = Logger.get('PaginatedTextContainer');

  }

  /* //TODO
  * Move data fetching code or side effects to componentDidUpdate.
  * If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps.
  * Learn more at: https://fb.me/react-derived-state
  * Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 17.x, only the UNSAFE_ name will work.
  * To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.
  * */
  componentWillReceiveProps(nextProps) {
    if (nextProps.page !== undefined && nextProps.page !== this.currentPage) {
      this.currentPage =
        nextProps.page >= -1 && nextProps.page <= this.state.pages
          ? nextProps.page
          : this.currentPage;
    }

    if (
      (nextProps.text !== undefined && this.props.text !== nextProps.text) ||
      this.props.height !== nextProps.height ||
      this.props.isFullscreen !== nextProps.isFullscreen
    ) {
      setTimeout(() => {
        this.calculatePages(nextProps.text);
      }, 100);
    }

    if (
      // this.currentPage !== this.props.page &&
      this.state.pages > 0 &&
      this.state.data[this.currentPage] === undefined
    ) {
      if (
        this.props.page < nextProps.page &&
        this.currentPage === this.state.pages &&
        this.props[PAGINATION_EVENTS.onEndReached]
      ) {
        this.props[PAGINATION_EVENTS.onEndReached]();
      }

      if (
        this.props.page > nextProps.page &&
        this.currentPage === -1 &&
        this.props[PAGINATION_EVENTS.onBeginReached]
      ) {
        this.props[PAGINATION_EVENTS.onBeginReached]();
      }
    }
  }

  calculatePages(initialText) {
    if (!this.textContainer) {
      return this.logger.warn("container is empty");
    }

    if (initialText === undefined) {
      return this.logger.warn("text is empty");
    }

    const computedStyle = window.getComputedStyle(this.textContainer);
    let containerWidth = parseInt(computedStyle.getPropertyValue('width'), 10);
    let containerHeight = parseInt(computedStyle.getPropertyValue('height'), 10);
    let paragraphs = initialText.split(/\n/);

    // fix for ff && ie
    //example: normal normal 400 normal 23.04px / 34.56px sf_ui_displaylight
    let font =
      computedStyle.font.length > 0
        ? computedStyle.font
        : (
          computedStyle.fontStyle + ' ' +
          computedStyle.fontWeight + ' ' +
          computedStyle.fontSize + ' / ' +
          computedStyle.lineHeight + ' ' +
          computedStyle.fontFamily
        );
    const lineHeight = parseFloat(computedStyle.lineHeight, 10)
    const rowHeight = isNaN(lineHeight) ? 1.25 : lineHeight;
    let rowsPerPage = Math.floor(containerHeight / rowHeight);
    let spaceWidth = this.getTextWidth(" ", font);
    let dotsWidth = this.getTextWidth("...", font);
    let countOfWordsInRow = 0;
    let data = [];
    let pageText = [];
    let words = '';
    let mainWidth = 0;
    let pages = 1;
    let rows = 1;

    // add additional line breaks for new lines - based on \n
    paragraphs.forEach((paragraph, paragraphIndex) => {
      words = paragraph.split(/\s/);
      words.forEach((word, i) => {
        let wordWidth = this.getTextWidth(word, font);

        if (mainWidth + dotsWidth + wordWidth + (spaceWidth * countOfWordsInRow) > containerWidth) {
          if ((rows + 1) > rowsPerPage) {
            pages++;
            if (pageText.indexOf("\n") !== -1) {
              data.push(pageText.join(" ").replace("/\n/", "/...\n/"));
            } else {
              data.push(pageText.join(" ") + '...');
            }

            pageText = [];
            rows = 0;
          }
          rows++;
          mainWidth = 0;
          countOfWordsInRow = 0;
        }

        pageText.push(word);
        mainWidth += wordWidth;
        countOfWordsInRow++;
      });

      // add only space if it is necessary
      if (paragraphs.length - 1 !== paragraphIndex) {
        // add space to the end of line
        mainWidth = containerWidth - dotsWidth;
        pageText.push("\n");
      }
    });

    data.push(pageText.join(" "));

    this.setState({
      pages,
      rowsPerPage,
      data,
    });
    this.currentPage = 0;
    this.props.changeTextAreaPage(this.currentPage + 1, this.state.pages);
  }

  getTextWidth(text, font) {
    // re-use canvas object for better performance
    const canvas = this.canvas || (this.canvas = document.createElement("canvas"));
    const context = canvas.getContext("2d");
    context.font = font;
    let metrics = context.measureText(text);
    return metrics.width;
  }

  render() {
    let current = this.currentPage;
    current = current < 0 ? 0 : current;
    current = current > this.state.pages - 1 ? this.state.pages - 1 : current;
    const { height } = this.props;
    const { data } = this.state;

    const containerHeight = height > 0 ? height - 70 : 0

    return (
      <div
        className="text-block"
        style={{ height: containerHeight }}
      >
        <p ref={(el) => { this.textContainer = el; }}>
          {data[current] && data[current].split('\n').map((item, key) => (
            <span key={key}>
              {item}
              <br />
            </span>
          ))}
        </p>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    height: getTextHeight(state),
  };
};

export default connect(mapStateToProps)(PaginatedTextContainer)



// WEBPACK FOOTER //
// ./src/components/PaginatedTextContainer.jsx